import { Component, OnInit } from '@angular/core';
import {  FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { Subscription } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { CCSaveBusinessDataService } from '../../../services/ccsave-business-data.service';
import { WithdrawalStatusService } from 'src/app/shared/services/withdrawal-status.service';
import { WithdrawalUploadFileService } from '../../../services/withdrawal-upload-file.service';
import { BehaviorSubjectActivationsService } from 'src/app/shared/services/behavior-subject-activations.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import { BusinessActivationData } from '../new-activation-page.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-business-legal-information',
  templateUrl: './business-legal-information.component.html',
  styleUrls: ['./business-legal-information.component.scss'],
})
export class BusinessLegalInformationComponent implements OnInit {
  fvlegalInfoForm = new FormValidatorService();
  fvRegisteredBusiness = new FormValidatorService();
  fvUnRegisteredBusiness = new FormValidatorService();
  registeredBusinessForm!: FormGroup;
  unRegisteredBusinessForm!: FormGroup;
  legalInfoForm!: FormGroup;
  subscriptions: Subscription[] = [];
  files = {} ;
  saveError: string;
  businessActivationData: BusinessActivationData;
  isUpdate: number;
  frontImage: string;
  backImage: string;
  imagesChanged: string[] = [];
  commercialImage: string;
  taxCardImage: string;
  isValid :boolean = false ;
  constructor(
    public sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private ng2ImgMax: Ng2ImgMaxService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private saveBusinessData: CCSaveBusinessDataService,
    private withdrawalStatusService: WithdrawalStatusService,
    private withdrawalUploadFileService: WithdrawalUploadFileService,
    private ActivationSubject: BehaviorSubjectActivationsService
  ) {}


  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {

      this.fvRegisteredBusiness.validationMessages = {
        "commercialRegister": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Commercial register',
            fieldAr: 'السجل التجاري'
          }),
        },
        "taxCard": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Tax card',
            fieldAr: 'بطاقة ضريبية'
          }),
        },
      }
      this.fvUnRegisteredBusiness.validationMessages = {

        "personalIdFront": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Personal id front',
            fieldAr: 'واجهة الهوية الشخصية'
          }),
        },
        "personalIdBack": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Personal id back',
            fieldAr: 'خلفية الهوية الشخصية'
          }),
        },
      }
    });
  }

  ngOnInit(): void {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    this.legalInfoForm = this.fvlegalInfoForm.createForm([
      {
        fieldName: 'hasRegisteredBusiness',
        defaultValue: true,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'This question is required',
          },
        ],
      },
    ]);
    this.registeredBusinessForm = this.fvRegisteredBusiness.createForm([
      {
        fieldName: 'taxCard',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'commercialRegister',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);
    this.unRegisteredBusinessForm = this.fvUnRegisteredBusiness.createForm([
      {
        fieldName: 'personalIdFront',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'personalIdBack',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);
  }
  get isRegisteredBusiess() {
    return this.legalInfoForm.controls['hasRegisteredBusiness'].value == true;
  }

  async onSubmit() {
    let legalFormData: LegalFormData;

    try {
      if (this.isRegisteredBusiess) {
        if (this.registeredBusinessForm.invalid) {
          this.fvRegisteredBusiness.forceShowErrors();
          return;
        } else {
          legalFormData = {
            ...this.registeredBusinessForm.value,
            ...this.legalInfoForm.value,
          };
        }
      } else {
        if (this.unRegisteredBusinessForm.invalid) {
          this.fvUnRegisteredBusiness.forceShowErrors();
          return;
        } else {
          legalFormData = {
            ...this.unRegisteredBusinessForm.value,
            ...this.legalInfoForm.value,
          };
        }
      }
      let fileNames = [];
      const formData = new FormData();
      for (const key of Object.keys(this.files)) {
        if (key) {
          if (legalFormData[key] == null) {
            legalFormData[key] = this.files[key];
          }
        }
      }
      const activationRequestObject: ActivationRequestData = {
        ...legalFormData,
        ...this.businessActivationData,
      };
      for (const name of Object.keys(activationRequestObject)) {
        if (
          [
            'personalIdBack',
            'personalIdFront',
            'commercialRegister',
            'taxCard',
          ].indexOf(name) > -1
        ) {
          fileNames.push(name);
        } else {
          formData.append(name, activationRequestObject[name]);
        }
      }
      this.saveBusinessData.setParams(formData);
      const result = await this.saveBusinessData.make();
      let showErrorImage = false;
      for (const fileName of fileNames) {
        let fileFormData = new FormData();
        fileFormData.append('fileName', fileName);
        fileFormData.append('requestId', result.id);
        fileFormData.append(fileName, this.files[fileName]);
        this.withdrawalUploadFileService.setParams(fileFormData);
        const res = await this.withdrawalUploadFileService.make();
        if (!res || !res.location) {
          showErrorImage = true;
          break;
        }
      }
      if (showErrorImage) {
        this.snackBar.open(
          this.translate.instant('Sellers.Products.CannotUploadImage'),
          '',
          {
            duration: 5000,
          }
        );
        return;
      }
      await this.showActivationRequestDisclaimer();
      this.withdrawalStatusService.refetchBS.next(true);
      this.ActivationSubject.renderData.next(true);

      this.snackBar.open(
        this.translate.instant('Sellers.Products.OrderPlaced'),
        '',
        {
          duration: 3000,
        }
      );
    } catch (error) {
      console.log('error: ', error);
      this.saveError = error.message || error.faultyRequest.error.error;
    }
  }
  async initFormValues (oldValues){
    if (oldValues.hasRegisteredBusiness){
      this.legalInfoForm.controls['hasRegisteredBusiness'].setValue(true)
      if (oldValues.commercialRegister && oldValues.taxCard){this.isValid = true}
    }else{
      this.legalInfoForm.controls['hasRegisteredBusiness'].setValue(false)
      if (oldValues.personalIdFront && oldValues.personalIdFront){this.isValid = true}
    }

  }
  async showActivationRequestDisclaimer() {
    return await Swal.fire({
      icon: 'info',
      showCloseButton: true,
      title: `${this.translate.instant('Sellers.Products.Disclaimer')}`,
      text: `${this.translate.instant(
        'Sellers.Dashboard.ActivationDisclaimer'
      )}`,
    });
  }
  fileChange(controlName, e, type) {
    this.isValid = false ;
    this.files[controlName] = <File>e.target.files[0];
    if (type == 'frontImg') {
      this.frontImage = this.files[controlName].name;
      this.imagesChanged.push('personalIdFront');
    } else if (type == 'backImg') {
      this.backImage = this.files[controlName].name;
      this.imagesChanged.push('personalIdBack');
    } else if (type == 'commercialImg') {
      this.commercialImage = this.files[controlName].name;
      this.imagesChanged.push('commercialRegister');
    } else if (type == 'taxCardImg') {
      this.taxCardImage = this.files[controlName].name;
      this.imagesChanged.push('taxCard');
    }

    this.subscriptions.push(
      this.ng2ImgMax.compressImage(this.files[controlName], 0.2, true).subscribe(
        (result) => {
          const image = new File([result], result.name);
          this.files[controlName] = image;
        },
        (error) => {
          console.log('there is an', error);
        }
      )
    );
  }
  onRadioChange(event: MatRadioChange) {
    this.isValid = false;
    this.imagesChanged.splice(0);
    this.files = {};
    this.registeredBusinessForm.reset();
    this.unRegisteredBusinessForm.reset();
    this.fvRegisteredBusiness.formErrors = null;
    this.fvUnRegisteredBusiness.formErrors = null;
  }
  isComponentValid() {
    if (this.isValid) return true ;
    if (this.isRegisteredBusiess) {
      if (this.registeredBusinessForm.valid) {
        return true;
      }
      return false;
    } else {
      if (this.unRegisteredBusinessForm.valid) {
        return true;
      }
      return false;
    }
  }
  showComponentErrors() {
    if (this.isRegisteredBusiess) {
      if (this.registeredBusinessForm.invalid) {
        this.fvRegisteredBusiness.forceShowErrors();
      }
    } else {
      if (this.unRegisteredBusinessForm.invalid) {
        this.fvUnRegisteredBusiness.forceShowErrors();
      }
    }
    this.snackBar.open(
      this.translate.instant('Sellers.Products.Invalid_legal_Info'),
      '',
      {
        duration: 5000,
      }
    );
  }

  showFormErrors(errors) {
    if (errors.validationErrors?.error) {
      for (const e of errors.validationErrors.error) {
        this.fvlegalInfoForm.addError(e.field, 'invalid', e.message);
        this.legalInfoForm.controls[e.field].setErrors({ invalid: e.message });
        this.fvlegalInfoForm.ShowErrors();
      }
    }
  }
}
export interface ActivationRequestData
  extends BusinessActivationData,
    LegalFormData {}
interface LegalFormData {
  hasRegisteredBusiness: string;
  commercialRegister: string;
  taxCard: string;
  personalIdFront: string;
  personalIdBack: string;
}
